import axios from "../../../js/project-axios.js";

const list = username => {
    return axios.get("/admin/user/list", {
        params: {
            username
        }
    });
};

const resetPassword = user => {
    return axios.post("/admin/user/resetPassword", user);
};

export default {
    list,
    resetPassword
};